/**
 * GENERATED FILE. Do not edit.
 *
 * Source: packages/shared/registry/value-types.json
 * Rebuild: bun run registry:build
 */

import type { ComponentId } from './component-ids';

/** The closed 18. Mirrors the app.field_type enum in Postgres. */
export const VALUE_TYPE_IDS = [
  'text',
  'long_text',
  'number',
  'money',
  'quantity',
  'date',
  'datetime',
  'boolean',
  'select',
  'multi_select',
  'reference',
  'attachment',
  'phone',
  'location',
  'formula',
  'rollup',
  'lookup',
  'lines',
  'series',
] as const;

export type ValueTypeId = (typeof VALUE_TYPE_IDS)[number];

/** Where the value lives. Section 5.2 of the architecture plan. */
export type ValueTypeHome = 'numeric_slot' | 'text_slot' | 'time_slot' | 'reference_slot' | 'boolean_slot' | 'link_table' | 'attrs' | 'computed' | 'child_record';

export type ValueType = {
  readonly id: ValueTypeId;
  readonly home: ValueTypeHome;
  /** The component that must never break. Every ladder ends here. */
  readonly primitive: ComponentId;
  readonly list_cell: string;
  readonly filter_control: string;
};

export const VALUE_TYPES: { readonly [K in ValueTypeId]: ValueType } = {
  'text': { id: 'text', home: 'text_slot', primitive: 'text.plain', list_cell: 'text', filter_control: 'contains' },
  'long_text': { id: 'long_text', home: 'text_slot', primitive: 'text.multiline', list_cell: 'first_line', filter_control: 'contains' },
  'number': { id: 'number', home: 'numeric_slot', primitive: 'number.plain', list_cell: 'number', filter_control: 'range' },
  'money': { id: 'money', home: 'numeric_slot', primitive: 'money.calculator', list_cell: 'signed_amount', filter_control: 'range' },
  'quantity': { id: 'quantity', home: 'numeric_slot', primitive: 'number.plain', list_cell: 'number_with_unit', filter_control: 'range' },
  'date': { id: 'date', home: 'time_slot', primitive: 'date.picker', list_cell: 'date', filter_control: 'range' },
  'datetime': { id: 'datetime', home: 'time_slot', primitive: 'date.picker', list_cell: 'date_time', filter_control: 'range' },
  'boolean': { id: 'boolean', home: 'boolean_slot', primitive: 'boolean.switch', list_cell: 'tick', filter_control: 'yes_no' },
  'select': { id: 'select', home: 'reference_slot', primitive: 'select.chips', list_cell: 'chip', filter_control: 'choose_many' },
  'multi_select': { id: 'multi_select', home: 'link_table', primitive: 'reference.multi_picker', list_cell: 'chips', filter_control: 'choose_many' },
  'reference': { id: 'reference', home: 'reference_slot', primitive: 'reference.search_picker', list_cell: 'target_title', filter_control: 'choose_many' },
  'attachment': { id: 'attachment', home: 'attrs', primitive: 'file.picker', list_cell: 'thumbnail', filter_control: 'present_absent' },
  'phone': { id: 'phone', home: 'text_slot', primitive: 'text.phone', list_cell: 'phone_tap_to_call', filter_control: 'contains' },
  'location': { id: 'location', home: 'attrs', primitive: 'map.picker', list_cell: 'place_name', filter_control: 'within' },
  'formula': { id: 'formula', home: 'computed', primitive: 'value.readonly', list_cell: 'value', filter_control: 'range' },
  'rollup': { id: 'rollup', home: 'computed', primitive: 'value.readonly', list_cell: 'value', filter_control: 'range' },
  'lookup': { id: 'lookup', home: 'computed', primitive: 'value.readonly', list_cell: 'value', filter_control: 'range' },
  'lines': { id: 'lines', home: 'child_record', primitive: 'lines.table', list_cell: 'line_count', filter_control: 'range' },
  'series': { id: 'series', home: 'numeric_slot', primitive: 'number.plain', list_cell: 'number', filter_control: 'range' },
};

/**
 * The one lookup that makes the "always renders" promise true. Exhaustive by
 * construction: the build refuses a value type with no primitive.
 */
export const PRIMITIVE_FOR: { readonly [K in ValueTypeId]: ComponentId } = {
  'text': 'text.plain',
  'long_text': 'text.multiline',
  'number': 'number.plain',
  'money': 'money.calculator',
  'quantity': 'number.plain',
  'date': 'date.picker',
  'datetime': 'date.picker',
  'boolean': 'boolean.switch',
  'select': 'select.chips',
  'multi_select': 'reference.multi_picker',
  'reference': 'reference.search_picker',
  'attachment': 'file.picker',
  'phone': 'text.phone',
  'location': 'map.picker',
  'formula': 'value.readonly',
  'rollup': 'value.readonly',
  'lookup': 'value.readonly',
  'lines': 'lines.table',
  'series': 'number.plain',
};

export function isValueTypeId(value: string): value is ValueTypeId {
  return (VALUE_TYPE_IDS as readonly string[]).includes(value);
}
